const SAVED_KEY = 'ihsanone.savedItems';

export const loadSavedItems = () => {
  try {
    const raw = localStorage.getItem(SAVED_KEY);
    return new Set(raw ? JSON.parse(raw) : []);
  } catch {
    return new Set();
  }
};

export const toggleSavedItem = (id) => {
  const current = loadSavedItems();
  if (current.has(id)) {
    current.delete(id);
  } else {
    current.add(id);
  }
  try {
    localStorage.setItem(SAVED_KEY, JSON.stringify([...current]));
  } catch {
    // ignore quota / privacy-mode errors
  }
  return current;
};
